<!-- @format -->

<fudis-dialog [size]="'sm'">
  <fudis-heading [level]="2" fudisDialogTitle>{{ values?.titleKey | translate }}</fudis-heading>
  <fudis-dialog-content [contentFocus]="true">
    @if (values?.messageKey) {
      <fudis-body-text>{{ values.messageKey | translate }}</fudis-body-text>
    }
    @for (error of values?.validationErrors; track error) {
      <fudis-body-text>
        {{ error.messageKey | translate: error.attributes }}{{ error.entityKey ? ":" : "" }}
        @if (error.entityKey) {
          {{ "ENTITY_NAMES." + error.entityKey | translate }}
          @if (error.fieldKeys?.length > 0) {
            >
          }
          @for (fieldKey of error.fieldKeys; track fieldKey; let last = $last) {
            {{ "FIELD_NAMES." + fieldKey | translate }}
            @if (!last) {
              >
            }
          }
        }
      </fudis-body-text>
    }
  </fudis-dialog-content>
  <fudis-dialog-actions>
    <fudis-button fudisDialogClose [label]="'COMMON.CLOSE_ERROR' | translate" />
  </fudis-dialog-actions>
</fudis-dialog>
